<template>
  <div id="nearby-place">
    <div class="tab-header">
      <v-row>
        <v-col sm="6">
          <label class="tab-title">{{ $t("NEARBY_PLACE") }}</label>
        </v-col>
        <v-col sm="6" class="text-right">
          <button class="btn btn-save" @click="save">{{ $t("SAVE") }}</button>
        </v-col>
      </v-row>
    </div>
    <!-- binding list old items -->
    <div v-for="(landmark, landIndex) in listLandmark" :key="landmark.id">
      <div class="tab-content" :markId="landmark.id">
        <v-subheader class="px-0" style="height: 24px">
          {{
          landmark.i18ns.find(x => x.lang == langSystem).name
          }}
        </v-subheader>

        <!-- Không có item nào trong section, hiển thị row mặc định -->
        <v-row
          v-if="
            listUpdatedArea.find(x => x.markId == landmark.id).ares.length ==
              0 || defaultItems.find(x => x.markId == landmark.id).state
          "
          class="row-item default-item"
        >
          <v-col sm="4" name="vi">
            <label class="label-input">{{ $t("VIETNAMESE_NAME") }} {{ $t("REQUIRED") }}</label>
            <input-text
              :model.sync="
                defaultItems.find(x => x.markId == landmark.id).area.vi
              "
            />
          </v-col>
          <v-col sm="4" name="en">
            <label class="label-input">{{ $t("ENGLISH_NAME") }} {{ $t("REQUIRED") }}</label>
            <input-text
              :model.sync="
                defaultItems.find(x => x.markId == landmark.id).area.en
              "
            />
          </v-col>
          <v-col sm="3" name="distance">
            <label class="label-input">{{ $t("DISTANCE") }} *</label>
            <select-unit
              :regex="REGEX_DISTANCE"
              :items="unit"
              :model.sync="
                defaultItems.find(x => x.markId == landmark.id).area.distance
              "
              :unit.sync="
                defaultItems.find(x => x.markId == landmark.id).area.unit
              "
            />
          </v-col>
          <v-col sm="1" v-if="listNewArea.find(x => x.markId == landmark.id).ares.length">
            <v-icon
              color="indigo"
              class="btn-delete"
              @click="deleteArea(landmark.id, defaultItems.find(x => x.markId == landmark.id))"
            >delete</v-icon>
          </v-col>
        </v-row>
        <!-- Binding list updated items -->
        <v-row
          class="row-item"
          v-for="item in listUpdatedArea.find(x => x.markId == landmark.id)
            .ares"
          :key="item.areaId"
        >
          <v-col sm="4" name="vi">
            <label class="label-input">{{ $t("VIETNAMESE_NAME") }} {{ $t("REQUIRED") }}</label>
            <input-text :model.sync="item.i18ns[0].name" />
          </v-col>
          <v-col sm="4" name="en">
            <label class="label-input">{{ $t("ENGLISH_NAME") }} {{ $t("REQUIRED") }}</label>
            <input-text :model.sync="item.i18ns[1].name" />
          </v-col>
          <v-col sm="3" name="distance">
            <label class="label-input">{{ $t("DISTANCE") }} *</label>
            <select-unit
              :regex="REGEX_DISTANCE"
              :model.sync="item.distance"
              :items="unit"
              :unit.sync="item.cubit"
            />
          </v-col>
          <v-col sm="1">
            <v-icon color="indigo" class="btn-delete" @click="deleteArea(landmark.id, item)">delete</v-icon>
          </v-col>
        </v-row>
        <!-- Binding list new items -->
        <v-row
          class="row-item"
          v-for="(item, i) in listNewArea.find(x => x.markId == landmark.id)
            .ares"
          :key="i"
        >
          <v-col sm="4" name="vi">
            <label class="label-input">{{ $t("VIETNAMESE_NAME") }} {{ $t("REQUIRED") }}</label>
            <input-text :model.sync="item.i18ns[0].name" />
          </v-col>
          <v-col sm="4" name="en">
            <label class="label-input">{{ $t("ENGLISH_NAME") }} {{ $t("REQUIRED") }}</label>
            <input-text :model.sync="item.i18ns[1].name" />
          </v-col>
          <v-col sm="3" name="distance">
            <label class="label-input">{{ $t("DISTANCE") }} *</label>
            <select-unit
              :regex="REGEX_DISTANCE"
              :model.sync="item.distance"
              :items="unit"
              :unit.sync="item.unit"
            />
          </v-col>
          <v-col sm="1">
            <v-icon color="indigo" class="btn-delete" @click="deleteArea(landmark.id, item)">delete</v-icon>
          </v-col>
        </v-row>
        <!-- Button thêm mới item -->
        <div>
          <v-icon color="#173d8f" @click="addArea(landmark.id)">add</v-icon>
          <label class="has-action mb-0" @click="addArea(landmark.id)">
            {{
            $t("ADD_LOCATION")
            }}
          </label>
        </div>
      </div>
      <v-divider class="my-0" v-if="landIndex != listLandmark.length - 1" />
    </div>
  </div>
</template>

<script>
const DISTANCE_UNIT = ["km", "m"];
const MAX_ITEMS = 53;
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import SelectUnit from "@/components/Utils/SelectUnit.vue";
import { service } from "@/_services/GeneralInfomation/area.service.js";
import { _alert } from "@/_helpers/function.js";
import { REGEX_NUMBER, REGEX_DISTANCE } from "@/_helpers/constant.js";

export default {
  components: {
    "input-text": Input,
    "select-text": Select,
    "select-unit": SelectUnit
  },

  created() {
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='3']")
      .classList.add("v-tab--active");
  },
  data() {
    return {
      unit: DISTANCE_UNIT,
      defaultItems: [],
      listLandmark: [],
      listNewArea: [],
      listUpdatedArea: [],
      langSystem: this.$i18n.locale
    };
  },
  watch: {
    defaultItems: {
      handler(value) {
        value.forEach(x => {
          let state = false;
          let item = x.area;
          Object.keys(item).forEach(x => {
            if (item[x]) state = true;
          });
          x.state = state;
        });
      },
      deep: true
    }
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_DISTANCE() {
      return REGEX_DISTANCE;
    }
  },
  methods: {
    async initialize() {
      await service.getLandmark().then(res => {
        this.listLandmark = res.data;
        res.data.forEach(x => {
          this.listNewArea.push({
            markId: x.id,
            ares: []
          });
          // this.listUpdatedArea = [... this.listNewArea]
          this.listUpdatedArea.push({
            markId: x.id,
            ares: []
          });
          this.defaultItems.push({
            state: null,
            markId: x.id,
            area: {
              vi: null,
              en: null,
              distance: null,
              unit: null
            }
          });
        });
      });
      await service.getArea().then(res => {
        //res.data = res.data.slice(res.data.length - 8, res.data.length);
        this.listUpdatedArea.forEach(x => {
          let landmarkId = x.markId;
          res.data.forEach(y => {
            if (!y.i18ns || !y.i18ns[0] || !y.i18ns[1]) {
              y.i18ns.push({ lang: "vi", name: "" }, { lang: "vi", name: "" });
            }
            if (y.landmark && y.landmark.id == landmarkId) {
              let convert = {
                areaId: y.id,
                distance: y.distance,
                cubit: y.unit,
                i18ns: y.i18ns
              };
              x.ares.push(convert);
            }
          });
        });
      });
      this.$forceUpdate();
    },
    addArea(landmarkId) {
      let landmark = this.listNewArea.find(x => x.markId == landmarkId);
      landmark.ares.push({
        distance: null,
        unit: null,
        i18ns: [{ lang: "vi", name: "" }, { lang: "en", name: "" }]
      });
      this.$forceUpdate();
    },
    validate() {
      // Validate list default items
      let isValid = true;
      let page = document.getElementById("nearby-place");
      let group = page.querySelectorAll(".tab-content");
      group.forEach(x => {
        let isSingleItem = x.querySelectorAll(".row-item").length == 1;
        x.querySelectorAll(".row-item").forEach(x => {
          let selectUnit = x.querySelector(".ex-select");
          let inputs = [...x.getElementsByTagName("input")];
          let value = inputs.concat(selectUnit).map(x => {
            return x.value || x.innerText;
          });
          // Có 1 item trong group
          if (
            isSingleItem &&
            value.filter(x => x).length > 0 &&
            value.filter(x => x).length < value.length
          ) {
            inputs
              .filter(x => !x.value)
              .forEach(x => {
                x.classList.add("invalid");
              });
            if (!selectUnit.value) selectUnit.classList.add("invalid");
            isValid = false;
          }
          // Có nhiều hơn 1
          if (!isSingleItem && value.filter(x => !x).length > 0) {
            inputs
              .filter(x => !x.value)
              .forEach(x => {
                x.classList.add("invalid");
              });
            if (!selectUnit.value) selectUnit.classList.add("invalid");
            isValid = false;
          }
        });
      });
      return isValid;
    },
    async save() {
      let element = document.querySelector(".btn-save");
      element.disabled = true;
      let isValid = this.validate();
      if (!isValid) {
        element.disabled = false;
        _alert(null, this.$t("MISSING_FIELD"), false);
        return false;
      }
      let promises = [];
      let tempDefaultItems = [];
      this.defaultItems.forEach(x => {
        let key = Object.keys(x.area)[0];
        if (x.area[key]) {
          let ares = Object.assign({}, x.area);
          ares.i18ns = [
            { lang: "vi", name: x.area.vi },
            { lang: "en", name: x.area.en }
          ];
          delete ares.vi;
          delete ares.en;
          tempDefaultItems.push({
            markId: x.markId,
            ares: [ares]
          });
        }
      });
      if (
        !this.listNewArea.map(x => x.ares).filter(x => x.length).length &&
        !this.listUpdatedArea.map(x => x.ares).filter(x => x.length).length &&
        !tempDefaultItems.length
      ) {
        _alert({ responseCode: 0 }, this.$t("UPDATE_SUCCESS"));
        return true;
      }
      this.listNewArea.concat(tempDefaultItems).forEach(x => {
        if (x.ares.length > 0) {
          promises.push(service.create(x));
        }
      });
      this.listUpdatedArea.forEach(x => {
        if (x.ares.length > 0) {
          x.ares.forEach(x => {
            x.unit = x.cubit;
            delete x.cubit;
          });
          promises.push(service.update(x));
        }
      });
      await Promise.all(promises).then(res => {
        let message;
        if (!res.find(x => x.responseCode != 0)) {
          _alert(res[0], this.$t(res[0].data));
        }
      });
    },
    deleteArea(markId, item) {
      let page = document.getElementById("nearby-place");
      let group = page.querySelector(`.tab-content[markId='${markId}']`);
      if (item.areaId) {
        service.remove([item.areaId]).then(res => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode == 0) {
            let ares = this.listUpdatedArea.find(x => x.markId == markId).ares;
            ares.splice(ares.indexOf(item), 1);
            if (group.querySelectorAll(".row-item").length == 2)
              group
                .querySelectorAll(".row-item")[0]
                .querySelectorAll(".invalid")
                .forEach(x => {
                  x.classList.remove("invalid");
                });
          }
        });
      } else {
        let ares = this.listNewArea.find(x => x.markId == markId).ares;
        if (ares.indexOf(item) > -1) {
          ares.splice(ares.indexOf(item), 1);
        } else {
          // Convert default item data
          let defaultItem = this.defaultItems.find(x => x.markId == markId);
          this.defaultItems.find(x => x.markId == markId).area = {
            vi: ares[0].i18ns.find(x => x.lang == "vi").name,
            en: ares[0].i18ns.find(x => x.lang == "en").name,
            distance: ares[0].distance,
            unit: ares[0].unit
          };
          ares.splice(0, 1);
        }
        if (group.querySelectorAll(".row-item").length == 2)
          group
            .querySelectorAll(".row-item")[0]
            .querySelectorAll(".invalid")
            .forEach(x => {
              x.classList.remove("invalid");
            });
      }
    }
  }
};
</script>
